import Logo from '../../icon/vdream_logo_center.png';
import { Link } from 'react-router-dom';
const Header = () => {
  return (
    <div className="flex w-full h-[88px] bg-[#333333] border-b border-[#CCCCCC]">
      <Link to="/resume">
        <div className="my-[20px] ml-[52px]">
          <img
            src={Logo}
            aria-label="브이드림 로고"
            className="h-[52px] w-auto"
          />
        </div>
      </Link>
      {/* <div className="hidden md:ml-auto md:my-[32px] md:flex">
        <span>KOR</span>
        <img
          src={HEADER_SMALL_ARROW}
          className="ml-[6px]"
        />
      </div>
      <div className="hidden md:mr-[40px] md:ml-[20px] md:my-[32px] md:flex">
        <span>FAMILY SITE</span>
        <img
          src={HEADER_SMALL_ARROW}
          className="ml-[6px]"
        />
      </div> */}
    </div>
  );
};

export default Header;
